module.exports = __webpack_public_path__ + "img/7.e3422ed3.jpg";